import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CsrfInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Always send cookies with requests
    let clonedRequest = req.clone({ withCredentials: true });

    const csrfToken = this.getCookie('XSRF-TOKEN');
    if (csrfToken) {
      clonedRequest = clonedRequest.clone({ setHeaders: { 'X-XSRF-TOKEN': csrfToken } });
    }

    return next.handle(clonedRequest);
  }

  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null;
    }
    return null;
  }
}
